import React from "react";
import Footer from "../components/utils/Footer";
import Carousel from "../components/carousel/Carousel";
import decalsAndSignageList from "../components/carousel/decalsAndSignageList";
import ServiceDescription from "../components/utils/ServiceDescription";
import CallToAction from "../components/utils/CallToAction";
import PhotoGrid from "../components/utils/PhotoGrid";
import Faq from "../components/faq/Faq";
import decalsAndSignageFaq from "../components/faq/decalsAndSignageFaq";
import NavBar from "../components/utils/NavBar";

const DecalsAndSignage = () => {
  return (
    <div className="">
      <div className="h-[calc(100dvh)] bg-black w-screen antialiased overscroll-contain overflow-x-hidden ">
        <NavBar />{" "}
        <ServiceDescription
          title={"DECALS & SIGNAGE"}
          content={`
Decals and signage offer a powerful way to enhance your brand's visibility and communicate effectively. Stickers provide a versatile and eye-catching means of promotion, while yard signs act as impactful markers for events or businesses. Banners, with their customizable options, serve as attention-grabbing displays for conveying messages or promotions. Together, this trio creates a comprehensive toolkit for elevating your brand presence, leaving a lasting and memorable impression on your audience.
`}
        />
        <Carousel
          CarouselTitle={"What We Can Do For You."}
          breakPoint={"lg:justify-center"}
          CarouselCardList={decalsAndSignageList}
        />
        <PhotoGrid />
        <CallToAction />
        <Faq questionsList={decalsAndSignageFaq} />
        <Footer />
      </div>
    </div>
  );
};

export default DecalsAndSignage;
